import { ACTION_TYPE } from 'src/modules/assistant/constants/actions';
import { TActionHandler } from './types';
import {
    aiCall,
    call,
    createAppointment,
    createTask,
    replyWhatsapp,
    sendEmail,
    sendTemplate,
} from './handlers';

const ACTION_HANDLERS: Readonly<Record<string, TActionHandler>> = Object.freeze(
    {
        [ACTION_TYPE.SEND_TEMPLATE]: sendTemplate,
        [ACTION_TYPE.REPLY_WHATSAPP]: replyWhatsapp,
        [ACTION_TYPE.SEND_EMAIL]: sendEmail,
        [ACTION_TYPE.CREATE_TASK]: createTask,
        [ACTION_TYPE.CREATE_APPOINTMENT]: createAppointment,
        [ACTION_TYPE.CALL]: call,
        [ACTION_TYPE.AI_CALL]: aiCall,
    }
);

export const getActionHandler = (type: string): TActionHandler | null =>
    ACTION_HANDLERS[type] || null;
